import * as React from 'react';
import { useContext, useState, useCallback } from 'react';
import { ThemeContext } from 'styled-components';
import { DismissingCard } from '../DismissingCard/index.js';
import { thumbsUpIconPath, thumbsDownIconPath } from './icons/ThumbsIcons.js';
import { Title, Paragraph, IconsWrap, IconContainer, Circle, CircleBackground, StyledTextArea } from './styles.js';
import { SonntagIcon } from '../SonntagIcon/SonntagIcon.js';
import { SonntagButton } from '../Buttons/SonntagButtonV2/SonntagButton.js';

const SatisfactionCard = ({ className , hasCircleDismissButton , onDismiss , dismissedText , undoButtonText , copy , preventThumbsUp , preventThumbsDown , onThumbsUpClick , onThumbsDownClick , onSubmitComment , handleChange , feedbackMessage  })=>{
    const theme = useContext(ThemeContext);
    const [step, setStep] = useState(1);
    const [vote, setVote] = useState("");
    const recordPositiveOutcome = useCallback(()=>{
        if (!preventThumbsUp) {
            setVote("up");
            setStep(step + 1);
        }
        onThumbsUpClick();
    }, [
        step,
        onThumbsUpClick,
        preventThumbsUp
    ]);
    const recordNegativeOutcome = useCallback(()=>{
        if (!preventThumbsDown) {
            setVote("down");
            setStep(step + 1);
        }
        onThumbsDownClick();
    }, [
        step,
        onThumbsDownClick,
        preventThumbsDown
    ]);
    const sendFeedback = useCallback(()=>{
        onSubmitComment();
        setStep(step + 1);
    }, [
        step,
        onSubmitComment
    ]);
    const renderContent = ()=>{
        if (step === 1) {
            var _copy_voteStep, _copy_voteStep1;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Title, null, copy === null || copy === void 0 ? void 0 : (_copy_voteStep = copy.voteStep) === null || _copy_voteStep === void 0 ? void 0 : _copy_voteStep.title), /*#__PURE__*/ React.createElement(Paragraph, null, copy === null || copy === void 0 ? void 0 : (_copy_voteStep1 = copy.voteStep) === null || _copy_voteStep1 === void 0 ? void 0 : _copy_voteStep1.body), /*#__PURE__*/ React.createElement(IconsWrap, null, /*#__PURE__*/ React.createElement(IconContainer, {
                onClick: recordPositiveOutcome
            }, /*#__PURE__*/ React.createElement(Circle, null, /*#__PURE__*/ React.createElement(CircleBackground, null), /*#__PURE__*/ React.createElement(SonntagIcon, {
                "data-testid": "satisfaction-card-thumps-up-icon",
                iconPath: thumbsUpIconPath,
                size: 28,
                color: theme.colors.Color2_75
            }))), /*#__PURE__*/ React.createElement(IconContainer, {
                onClick: recordNegativeOutcome
            }, /*#__PURE__*/ React.createElement(Circle, null, /*#__PURE__*/ React.createElement(CircleBackground, null), /*#__PURE__*/ React.createElement(SonntagIcon, {
                "data-testid": "satisfaction-card-thumps-down-icon",
                iconPath: thumbsDownIconPath,
                size: 28,
                color: theme.colors.Color2_75
            })))));
        }
        if (step === 2) {
            var _copy_commentStep, _copy_commentStep1, _copy_commentStep2;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Title, null, copy === null || copy === void 0 ? void 0 : (_copy_commentStep = copy.commentStep) === null || _copy_commentStep === void 0 ? void 0 : _copy_commentStep.title), /*#__PURE__*/ React.createElement(Paragraph, null, copy === null || copy === void 0 ? void 0 : (_copy_commentStep1 = copy.commentStep) === null || _copy_commentStep1 === void 0 ? void 0 : _copy_commentStep1.body), /*#__PURE__*/ React.createElement(StyledTextArea, {
                id: "feedback-text-area",
                name: "textarea",
                value: feedbackMessage,
                onChange: handleChange
            }), /*#__PURE__*/ React.createElement(SonntagButton, {
                type: "submit",
                size: "small",
                onClick: sendFeedback
            }, copy === null || copy === void 0 ? void 0 : (_copy_commentStep2 = copy.commentStep) === null || _copy_commentStep2 === void 0 ? void 0 : _copy_commentStep2.buttonLabel));
        }
        if (step === 3 && vote === "up") {
            var _copy_positiveOutcome, _copy_positiveOutcome1;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Title, null, copy === null || copy === void 0 ? void 0 : (_copy_positiveOutcome = copy.positiveOutcome) === null || _copy_positiveOutcome === void 0 ? void 0 : _copy_positiveOutcome.title), /*#__PURE__*/ React.createElement(Paragraph, null, copy === null || copy === void 0 ? void 0 : (_copy_positiveOutcome1 = copy.positiveOutcome) === null || _copy_positiveOutcome1 === void 0 ? void 0 : _copy_positiveOutcome1.body));
        }
        if (step === 3 && vote === "down") {
            var _copy_negativeOutcome, _copy_negativeOutcome1;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Title, null, copy === null || copy === void 0 ? void 0 : (_copy_negativeOutcome = copy.negativeOutcome) === null || _copy_negativeOutcome === void 0 ? void 0 : _copy_negativeOutcome.title), /*#__PURE__*/ React.createElement(Paragraph, null, copy === null || copy === void 0 ? void 0 : (_copy_negativeOutcome1 = copy.negativeOutcome) === null || _copy_negativeOutcome1 === void 0 ? void 0 : _copy_negativeOutcome1.body));
        }
        return null;
    };
    return /*#__PURE__*/ React.createElement(DismissingCard, {
        className: className,
        onDismiss: onDismiss,
        hasCircleButton: hasCircleDismissButton,
        dismissedText: dismissedText,
        undoButtonText: undoButtonText,
        hasTimeout: true
    }, renderContent());
};

export { SatisfactionCard };
